<template>
  <div id="report">
    <div class="full-overlay">
      <div class="overlay-header">
        <b-container fluid>
          <b-row align-h="center" align-v="center" class="my-md-4">
            <b-col>
            </b-col>
            <b-col cols="7">
              <div class="overlay-subnav text-center" v-if="$route.name != 'Results'" >
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) === 0" variant="link"  :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)-1]"><icon scale="2" name="angle-left"/></b-button>
                <span class="subnav-progress">
                  <router-link class="item" :key="index" v-for="(report, index) in $parent.availableReports" :class="{'active': report === $parent.openedReport}" :to="report"></router-link>
                </span>
                <b-button class="icon--color" style="vertical-align: top;" :disabled="$parent.availableReports.indexOf($parent.openedReport) >= $parent.availableReports.length -1" variant="link" :to="$parent.availableReports[$parent.availableReports.indexOf($parent.openedReport)+1]"><icon scale="2" name="angle-right"/></b-button>
              </div>
            </b-col>
            <b-col class="text-right">
              <b-button class="icon--color" variant="link" to="/personal/results" id="close-button"><icon name="times" scale="2"/></b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <div class="overlay-content">
        <b-container fluid class="px-0 pt-0 pb-4">
          <b-row align-v="center" align-h="center" class="py-4 mb-5 card--text">
            <b-col cols="12" sm="12" md="10" class="text-center p-3">
              <h1 class="info-headline">{{$t('common:title-absorption')}}</h1>
              <h5><span>{{ $t('common:description-personal-absorption') }}</span></h5>
            </b-col>
          </b-row>
        </b-container>
        <b-container fluid class="pt-0 pb-3">
          <div v-if="$parent.currentEngagementReport.stats">
            <!-- ABSORPTION STATUS -->
            <b-row align-v="center" align-h="center" class="mt-2">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col>
                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0($parent.currentEngagementReport.stats['uwes9-absorption'].avg/6.0*100)}}</span>
                      <span class="--scale">/ 100</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': $parent.personalUWESPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentEngagementReport.categories['uwes9-absorption']), 'width': $parent.formatPercent($parent.currentEngagementReport.stats['uwes9-absorption'].avg / 6)}"></div>
                    </div>
                    <p class="tidbit">{{$t('common:updated')}} {{$parent.currentEngagementReport.stats['uwes9-absorption'].updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span>{{ $t('personal-results:absorption-classification-title-' + $parent.currentEngagementReport.categories['uwes9-absorption']) }}</span>
                </h3>
              </b-col>
            </b-row>
            <!-- ABSORPTION CHANGE -->
            <b-row v-if="$parent.uwesAbsorptionChange !== null" align-v="center" align-h="center" class="my-5">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <div class="trend-indicator" :class="{'up': $parent.uwesAbsorptionChange >= 0.77, 'down': $parent.uwesAbsorptionChange <= -0.77, 'flat': Math.abs($parent.uwesAbsorptionChange) < 0.77 }">
                  <icon class="--icon mr-1" style="color: #377771;" v-if="$parent.uwesAbsorptionChange > 0" name="caret-up"/>
                  <icon class="--icon mr-1" style="color: #ed6a5e;" v-if="$parent.uwesAbsorptionChange < 0" name="caret-down"/>
                  <icon class="--icon mr-1" style="color: #377771;" v-if="$parent.uwesAbsorptionChange == 0" name="minus"/>
                  <div class="--magnitude">
                    <span class="--value">{{Math.abs($parent.formatNumber0($parent.uwesAbsorptionChange/6.0*100))}}</span>
                  </div>
                </div>
                <div class="--reference-point">{{$t('personal-results:from')}} {{$parent.formatNumber0($parent.currentEngagementReport.previous.absorption.avg / 6 * 100)}} / 100 ({{$parent.currentEngagementReport.previous.absorption.updatedAt | moment('MMMM YYYY')}})</div>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title">
                  <span v-if="$parent.currentAbsorptionDirectionClass !== null">{{ $t('personal-results:absorption-direction-title-' + $parent.currentAbsorptionDirectionClass) }}</span><span v-if="$parent.uwesAbsorptionChange !== 0 && $parent.currentEngagementReport.categories['uwes9-absorption'] === $parent.currentEngagementReport.previous.absorption.class">{{ $t('personal-results:absorption-class-same-' + $parent.currentEngagementReport.previous.absorption.class) }}</span>
                  <span v-else-if="$parent.uwesAbsorptionChange > 0 && $parent.currentEngagementReport.categories['uwes9-absorption'] !== $parent.currentEngagementReport.previous.absorption.class">
                    {{ $t('personal-results:absorption-class-level-up-' + $parent.currentEngagementReport.previous.absorption.class + '--' + $parent.currentEngagementReport.categories['uwes9-absorption']) }}
                  </span>
                  <span v-else-if="$parent.uwesAbsorptionChange < 0 && $parent.currentEngagementReport.categories['uwes9-absorption'] !== $parent.currentEngagementReport.previous.absorption.class">
                    {{ $t('personal-results:absorption-class-level-down-' + $parent.currentEngagementReport.previous.absorption.class + '--' + $parent.currentEngagementReport.categories['uwes9-absorption']) }}
                  </span>
                </h3>

              </b-col>
            </b-row>
            <!-- ABSORPTION COMPARISON -->
            <b-row align-v="center" align-h="center" class="mt-2" v-if="$parent.hasDataForAbsorptionComparison">
              <b-col cols="12" sm="12" md="5" order-md="2">
                <b-row>
                  <b-col cols="12">

                    <div class="overall-score">
                      <span class="--value">{{$parent.formatNumber0($parent.currentCompanyEngagementReport.stats['uwes9-absorption']/6.0*100)}}</span>
                      <span class="--scale">/ 100</span>
                    </div>

                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <div class="animated-bar">
                      <div class="meter" :class="{'activated': $parent.companyAbsorptionPercent !== 0}" :style="{'background-color': $parent.mapColor($parent.currentCompanyEngagementReport.categories['uwes9-absorption']), 'width': $parent.companyAbsorptionPercent}"></div>
                    </div>
                    <p class="tidbit">{{$t('personal-results:current-average-of-team', {account: $store.state.account.name})}}, {{$t('common:updated')}} {{$parent.currentCompanyEngagementReport.updatedAt | moment('from')}}.</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" md="5" order-md="1">
                <h3 class="feedback-title" v-if="$parent.getAbsorptionDifferenceDegree() === 0">{{$t('personal-results:team-absorption-comparison-0')}}</h3>
                <h3 class="feedback-title" v-if="$parent.getAbsorptionDifferenceDegree() > 0 && $parent.getPersonalTeamAbsorptionDifference() < 0">{{$t('personal-results:team-absorption-comparison-below-' + $parent.getAbsorptionDifferenceDegree())}}</h3>
                <h3 class="feedback-title" v-if="$parent.getAbsorptionDifferenceDegree() > 0 && $parent.getPersonalTeamAbsorptionDifference() > 0">{{$t('personal-results:team-absorption-comparison-above-' + $parent.getAbsorptionDifferenceDegree())}}</h3>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>
      <div class="overlay-footer d-none d-md-block">
        <b-container fluid>
          <b-row align-h="center">
            <b-col class="text-center mt-3 mb-3 my-md-4">
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted: function () {
    this.$parent.openedReport = 'absorption'
  }
}
</script>

<style lang="scss" scoped>
</style>
